import {
  ICreateBadgesResponse,
  IIssuancePaginatedResponseModel,
} from "../../types/interfaces";
import {
  IGetBadgesData,
  IGetBadgesDataFailed,
  IGetBadgesDataSuccess,
  BadgesActionsTypes,
  ISelectBadgeId,
  IDeleteBadgeFailed,
  IDeleteBadgeSuccess,
  IDeleteBadge,
  ICreateBadges,
  ICreateBadgesSuccess,
  ICreateBadgesFailed,
  ICleanCreateBadgesResponse,
} from "./badgesTypes";

// SELECT DATA
export const selectBadgeId = (badgeId?: string): ISelectBadgeId => {
  return {
    type: BadgesActionsTypes.SELECT_BADGE_ID,
    payload: {
      badgeId,
    },
  };
};

// GET DATA
export const getBadgesData = (
  param?: string,
  searchValue?: string,
  page?: number,
  size?: number
): IGetBadgesData => {
  return {
    type: BadgesActionsTypes.GET_BADGES_DATA,
    payload: {
      param,
      searchValue,
      page,
      size,
    },
  };
};

export const getBadgesDataSuccess = (
  data: IIssuancePaginatedResponseModel
): IGetBadgesDataSuccess => {
  const { items, links, pageSize, self, total } = data;
  return {
    type: BadgesActionsTypes.GET_BADGES_DATA_SUCCESS,
    payload: {
      items,
      links,
      pageSize,
      self,
      total,
    },
  };
};

export const getBadgesDataFailed = (error: string): IGetBadgesDataFailed => {
  return {
    type: BadgesActionsTypes.GET_BADGES_DATA_FAILED,
    payload: {
      error: error,
    },
  };
};

// DELETE BADGE
export const deleteBadge = (badgeId: string): IDeleteBadge => {
  return {
    type: BadgesActionsTypes.DELETE_BADGE,
    payload: {
      badgeId,
    },
  };
};

export const deleteBadgeSuccess = (): IDeleteBadgeSuccess => {
  return {
    type: BadgesActionsTypes.DELETE_BADGE_SUCCESS,
  };
};

export const deleteBadgeFailed = (): IDeleteBadgeFailed => {
  return {
    type: BadgesActionsTypes.DELETE_BADGE_FAILED,
  };
};

// CREATE BADGES
export const createBadges = (
  campaignName: string,
  file: File
): ICreateBadges => {
  return {
    type: BadgesActionsTypes.CREATE_BADGES,
    payload: {
      campaignName,
      file,
    },
  };
};

export const createBadgesSuccess = (
  response: ICreateBadgesResponse
): ICreateBadgesSuccess => {
  return {
    type: BadgesActionsTypes.CREATE_BADGES_SUCCESS,
    payload: {
      response,
    },
  };
};

export const createBadgesFailed = (): ICreateBadgesFailed => {
  return {
    type: BadgesActionsTypes.CREATE_BADGES_FAILED,
  };
};

export const cleanCreateBadgesResponse = (): ICleanCreateBadgesResponse => {
  return {
    type: BadgesActionsTypes.CLEAN_CREATE_BADGES_RESPONSE,
  };
};
